export enum PRODUCT_STOCK_OPERATIONS {
  ADDED = 'ADDED',
  DISCOUNTED = 'DISCOUNTED',
}

export enum STOCK_OPERATIONS {
  ADDED = 'ADDED',
  DISCOUNTED = 'DISCOUNTED',
  REFOUND = 'REFOUND',
  EXCHANGE = 'EXCHANGE',
  REPLACEMENT = 'REPLACEMENT',
  RETURN_AS_DAMAGED = 'RETURN_AS_DAMAGED',
  REPLACE_FOR_REFUND = 'REPLACE_FOR_REFUND',
  SOLD = 'SOLD',
  COMBO_ASSEMBLY = 'COMBO_ASSEMBLY',
  COMBO_DISASSEMBLY = 'COMBO_DISASSEMBLY',
}

export enum STOCK_ACTIVITY_OPERATIONS {
  ADDED = 'ADDED',
  DISCOUNTED = 'DISCOUNTED',
  SET = 'SET',
}
